import { init } from '@module-federation/enhanced/runtime';
import { fallbackPlugin } from './fallbackPlugin';
import { legacyReactPlugin } from './legacyReact';

init({
  name: 'shell',
  remotes: [],
  plugins: [fallbackPlugin(), legacyReactPlugin()],
});
